'use client';

import React from "react";
import "./organizations-interest-page.modules.css";
import Footer from "@components/footer/Footer";
import Navbar from "@components/Navbar";

const OrganizationsInterestPage = () => {
  return (
    <>
      <Navbar />
      <div>
        {/* Hero Section */}
        <section className="hero-section">
          <h1>penguinlearn for Organizations</h1>
          <p>Open Your Doors to Kids Everywhere</p>
          <div className="buttons">
            <h2>Apply to Teach as an Organization</h2>
            <p>
              Or{" "}
              <a href="independent-teachers.html" className="link">
                Apply to Teach as an Individual
              </a>
            </p>
          </div>
        </section>

        {/* What Section */}
        <section className="what-section">
          <h2>What is penguinlearn?</h2>
          <p>
            penguinlearn offers live online classes for kids ages 7-18. Classes meet in small groups
            with learners and teachers from all over the world.
          </p>
        </section>

        {/* Inspire Section */}
        <section className="inspire-section">
          <h2>Inspire learners with your programming, within their homes.</h2>
          <p>
            Educational organizations like yours (theater programs, camps, museums, after-school programs, etc.)
            have been looking for ways to continue offering value to families even in a socially-distanced reality.
            We can help you do that.
          </p>
          <p>
            Penguinlearn support camps and organizations who want
            to bring classes and programming to learners all over the globe through live Zoom classes.
            Just because your doors are closed doesn’t mean you can’t share what’s inside.
          </p>
        </section>

        {/* Why Section */}
        <section className="why-section">
          <h2>Why penguinlearn?</h2>
          <div className="features">
            <div className="feature">
              <h3>Early adopter advantage</h3>
              <p>
                As an early adopter, you&apos;ll have the opportunity to launch your course in a less competitive market and grow alongside us.
              </p>
            </div>

            <div className="feature">
              <h3>Real Impact</h3>
              <p>
                Our goal is to make learning both fun and interactive. We offer organizations and teachers continuous opportunities to provide feedback, and as an early adopter, your insights will be invaluable in shaping the future of education.
              </p>
            </div>

            <div className="feature">
              <h3>Competitive Earnings</h3>
              <p>
                We help you expand your organization and generate sustainable revenue. You&apos;ll earn 80% of every class sale.
              </p>
            </div>
          </div>
        </section>

        {/* Apply Section */}
        <section className="apply-section">
          <h2>Apply to Teach as an Organization</h2>
          <div style={{ position: "relative", width: "100%", paddingTop: "150%", overflow: "hidden" }}>
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSfjWAxg7ee1NaI_WivG5pb0Aex5RQXAZmf2LWJyW7yrQFGIEQ/viewform?embedded=true"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                border: "none",
              }}
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
              title="Apply to Teach Form"
              allowFullScreen
            ></iframe>
          </div>

        </section>
      </div>
      <Footer />
    </>
  );
};

export default OrganizationsInterestPage;